import { getDefaultExportFromCjs } from " commonjsHelpers.js";
import { __require as requireAvia_dashjs } from "/home/runner/_work/vtg-avia-js/vtg-avia-js/libs/plugins/dashjs/dist/avia.dashjs.cjs";
var avia_dashjsExports = requireAvia_dashjs();
export { avia_dashjsExports as __moduleExports };
export default /*@__PURE__*/getDefaultExportFromCjs(avia_dashjsExports);